module.exports = "/_next/static/images/e10f80848e2971c118c14b50d51f7d2a.png";